export enum collaboratorAccessEnums {
  OWNER = 1,
  OWNER_NAME = 'Owner',
  EDITOR = 2,
  EDITOR_NAME = 'Editor',
  VIEWER = 3,
  VIEWER_NAME = 'Viewer',
}
